<template>
    <div class="filters-list">
        <form action="/search/" class="form">
            <label for="search-input" class="form__label w-search">
                <input class="w-search__submit" name="q" value="">
                <input v-model="q" type="text" class="form__input w-search__input" id="search-input" name="q" :placeholder="text.search">
            </label>
        </form>
        <div class="component__tab-filters tab-filters">
            <ul class="tab-filters__list ul--clear">
                <li
                    class="tab-filters__item"
                    v-for="(item, index) in data"
                    :key="index"
                >
                    <a
                        href="#"
                        class="tab-filters__link"
                        :class="{'tab-filters__link--active': type === item.name}"
                        @click.prevent="changeTab(item.name)"
                    >{{ item.name }}</a>
                </li>
            </ul>
        </div>
        <ul class="filters-list__list" v-if="filteredList && filteredList.length">
            <li
                v-for="(item, index) in filteredList"
                :key="index"
                v-html="item"
            >
            </li>
        </ul>
        <p class="u-top-margin--30" v-else v-html="text.unfound"></p>
    </div>
</template>

<script>

export default {
    name: 'filters-list',
    props: {
        data: Array
    },
    data () {
        return {
            q: '',
            type: '',
            text: {
                search: localize({
                    'ru': 'Поиск по нарушителям',
                    'en': 'Search by violators'
                }),
                unfound: localize({
                    'ru': 'К сожалению, ничего не найдено.',
                    'en': 'Unfortunately, nothing was found.'
                })
            }
        }
    },
    mounted () {
        this.type = this.data[0].name
    },
    computed: {
        filteredList () {
            let arr = this.data.find(i => i.name === this.type)
            if(this.q) {
                return arr.items.filter(i => i.match(this.q))
            }
            return arr.items
        }
    },
    methods: {
        changeTab (name) {
            this.type = name
        }
    }
}
</script>

<style lang="scss">
.filters-list {
    &__list {
        max-height: 400px;
        overflow-y: auto;
    }
}
</style>


// WEBPACK FOOTER //
// frontend/components/filters-list/filters-list.vue